/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import React from 'react';

import EntityCreateShareFormGroup from 'components/permissions/EntityCreateShareFormGroup';
import type { EntitySharePayload } from 'actions/permissions/EntityShareActions';

import useReportForm from './useReportForm';

const Share = () => {
  const { values, setFieldValue } = useReportForm();
  const handleEntityShareSet = (entityShare?: EntitySharePayload) => setFieldValue('share_request', entityShare);

  return (
    <EntityCreateShareFormGroup
      description="Search for a User or Team to add as collaborator on this report."
      onSetEntityShare={handleEntityShareSet}
      defaultSharePayload={values?.share_request}
      entityType="report"
      entityTitle=""
    />
  );
};

export default Share;
